import OrganizationInfoForm from './OrganizationInfoForm';

export default OrganizationInfoForm;


// WEBPACK FOOTER //
// ./src/features/organization/components/organization-info/index.js